import { render, staticRenderFns } from "./InitializationData.vue?vue&type=template&id=6b655374&scoped=true"
import script from "./InitializationData.vue?vue&type=script&lang=js"
export * from "./InitializationData.vue?vue&type=script&lang=js"
import style0 from "./InitializationData.vue?vue&type=style&index=0&id=6b655374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b655374",
  null
  
)

export default component.exports